<clr-modal [(clrModalOpen)]="modalOpen" [clrModalSize]="'xl'" [clrModalClosable]="false" id="settingsmodal">
  <h3 class="modal-title" style="display: flex">
    {{ 'Einstellungen' | mrTranslate }}
    <a
      href="javascript:void(0)"
      (click)="modalOpen = false; modalOpenChange.emit(false)"
      style="margin-left: auto; color: inherit">
      <cds-icon shape="times" />
    </a>
  </h3>

  <div class="modal-body">
    <div class="content-container">
      <clr-vertical-nav>
        <a
          clrVerticalNavLink
          href="javascript:void(0)"
          (click)="contentmode = 'allgemein'"
          [ngClass]="{ active: contentmode == 'allgemein' }">
          {{ 'Allgemein' | mrTranslate }}
        </a>
        <a
          clrVerticalNavLink
          href="javascript:void(0)"
          (click)="contentmode = 'bezeichnungen'"
          [ngClass]="{ active: contentmode == 'bezeichnungen' }">
          {{ 'Bezeichnungen' | mrTranslate }}
        </a>
        <a
          clrVerticalNavLink
          href="javascript:void(0)"
          (click)="contentmode = 'gismap'"
          [ngClass]="{ active: contentmode == 'gismap' }">
          {{ 'Gismap-API-Keys' | mrTranslate }}
        </a>
        <a
          clrVerticalNavLink
          href="javascript:void(0)"
          (click)="contentmode = 'kav'"
          [ngClass]="{ active: contentmode == 'kav' }">
          {{ 'KAV®' | mrTranslate }}
        </a>
        @if (allowInterfaces) {
          <a
            clrVerticalNavLink
            href="javascript:void(0)"
            (click)="contentmode = 'interface'"
            [ngClass]="{ active: contentmode == 'interface' }">
            {{ 'Schnittstellen' | mrTranslate }}
          </a>
        }
      </clr-vertical-nav>

      <div class="content-area">
        @switch (contentmode) {
          @case ('allgemein') {
            <div>
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Firma' | mrTranslate }}</strong>
                <br />
                @if (logo) {
                  <div class="clr-row">
                    <div class="clr-col-6">
                      <div>{{ 'Logo' | mrTranslate }}</div>
                      <div>
                        <img [src]="logo" (click)="fInput.click()" />
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="clr-col-6">
                    <div>{{ 'Logo' | mrTranslate }}</div>
                    <div>
                      <cds-icon class="icon" shape="plus-circle" (click)="fInput.click()" />
                    </div>
                  </div>
                }
                <br />
                <div class="clr-col-6">
                  <clr-input-container>
                    <label style="margin-left: 10px">{{ 'Name' | mrTranslate }}</label>
                    <input
                      style="min-width: 350px"
                      clrInput
                      [placeholder]="'Kunde-Name' | mrTranslate"
                      name="kunde"
                      formControlName="kunde" />
                  </clr-input-container>
                  <clr-input-container>
                    <label style="margin-left: 10px">{{ 'Ort' | mrTranslate }}</label>
                    <input
                      style="min-width: 350px"
                      clrInput
                      [placeholder]="'Kunde-Ort' | mrTranslate"
                      name="ort"
                      formControlName="ort" />
                  </clr-input-container>
                  <br />
                </div>
                <div class="clr-col-12">
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label>{{ 'Logo in Dokumentation übernehmen' | mrTranslate }}</label>
                      <input type="checkbox" clrCheckbox formControlName="OpLogoDok" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <br />
                  <clr-radio-container clrInline class="margin-0-t">
                    <label>{{ 'Logoposition' | mrTranslate }}</label>
                    <clr-radio-wrapper>
                      <input
                        type="radio"
                        name="OpLogoPosition"
                        clrRadio
                        value="0"
                        class="clr-radio"
                        formControlName="OpLogoPosition" />
                      <label>
                        {{ 'links' | mrTranslate }}
                      </label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input
                        type="radio"
                        name="OpLogoPosition"
                        clrRadio
                        value="1"
                        class="clr-radio"
                        formControlName="OpLogoPosition" />
                      <label>
                        {{ 'rechts' | mrTranslate }}
                      </label>
                    </clr-radio-wrapper>
                  </clr-radio-container>
                </div>
                <br />
                <input
                  #fInput
                  type="file"
                  id="fileUpload"
                  name="fileUpload"
                  accept="image/png"
                  style="display: none"
                  (change)="onLogoChanged($event)" />
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Anlagenverantwortlicher (ALV)' | mrTranslate }}</strong>
                <div class="clr-col-4">
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label style="min-width: 300px">
                        {{ 'ALV muss Prüfung bestätigen' | mrTranslate }}
                      </label>
                      <input type="checkbox" clrCheckbox formControlName="optChecked_EBL" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <br />
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label>
                        {{ 'automatische E-Mail für ALV und EBL' | mrTranslate }}
                      </label>
                      <input type="checkbox" clrCheckbox formControlName="optMeldung_EBL" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  @if (optionGroup.value.optMeldung_EBL) {
                    <clr-number-input-container>
                      <label style="margin-left: 10px">{{ 'Frist' | mrTranslate }}</label>
                      <input
                        clrNumberInput
                        type="number"
                        formControlName="optMeldungTage_EBL"
                        [min]="10"
                        [max]="90"
                        style="min-width: 80px" />
                    </clr-number-input-container>
                  }
                  <br />
                </div>
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Fehlerklassen' | mrTranslate }}</strong>
                <div class="d-f w-100-p">
                  <div class="clr-col-5" style="min-width: 45%">
                    <clr-number-input-container>
                      <label style="margin-left: 10px">{{ 'min' | mrTranslate }}</label>
                      <input
                        clrNumberInput
                        type="number"
                        formControlName="optMINNumFK"
                        [min]="0"
                        [max]="1"
                        style="min-width: 80px" />
                    </clr-number-input-container>
                    <clr-number-input-container>
                      <label style="margin-left: 10px">{{ 'max' | mrTranslate }}</label>
                      <input
                        clrNumberInput
                        type="number"
                        formControlName="optMAXNumFK"
                        [min]="3"
                        [max]="10"
                        style="min-width: 80px" />
                    </clr-number-input-container>
                    <clr-checkbox-container class="margin-0-t">
                      <clr-checkbox-wrapper>
                        <label>
                          {{ ('min' | mrTranslate) + ' = ' + ('Betriebsgefahr' | mrTranslate) }}
                        </label>
                        <input type="checkbox" clrCheckbox formControlName="optFk1_IstGleich_BG" />
                      </clr-checkbox-wrapper>
                    </clr-checkbox-container>
                    <br />
                    <clr-checkbox-container class="margin-0-t">
                      <clr-checkbox-wrapper>
                        <label>{{ 'nach unter änderbar' | mrTranslate }}</label>
                        <input type="checkbox" clrCheckbox formControlName="optDownChangeFK" />
                      </clr-checkbox-wrapper>
                    </clr-checkbox-container>
                  </div>
                  <div class="clr-col-7 wrapper" style="min-width: 45%">
                    @let rangeOptions = { start: optionGroup.value.optMINNumFK, stop: optionGroup.value.optMAXNumFK };
                    @for (i of rangeOptions | get: range; track i) {
                      <div>
                        <cds-icon
                          shape="circle"
                          solid="true"
                          [(colorPicker)]="fkcolor[i]"
                          class="cursor-pointer"
                          (colorPickerChange)="setColorFromPicker(i)"
                          [ngStyle]="{ color: fkcolor[i] }" />
                        <span>FK {{ i }}</span>
                      </div>
                    }
                    <button class="btn" (click)="fkcolor = defaultColors" title="{{ 'zurücksetzen' | mrTranslate }}">
                      <cds-icon shape="undo" size="32" />
                    </button>
                  </div>
                </div>
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Allgemein' | mrTranslate }}</strong>
                <div class="clr-col-4">
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label style="min-width: 300px">
                        {{ 'Export Auftrag Spezifikation' | mrTranslate }}
                      </label>
                      <input type="checkbox" clrCheckbox formControlName="optAuftragSpezExport" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label style="min-width: 300px">
                        {{ 'Export Mangelbilder im Auftrag' | mrTranslate }}
                      </label>
                      <input type="checkbox" clrCheckbox formControlName="optRepscheinPicture" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label>{{ 'Auftrag Workflow' | mrTranslate }}</label>
                      <input type="checkbox" clrCheckbox formControlName="optAuftrWF" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <clr-checkbox-container class="margin-0-t">
                    <clr-checkbox-wrapper>
                      <label>{{ 'PDF Dokumente signieren' | mrTranslate }}</label>
                      <input type="checkbox" clrCheckbox formControlName="optDokSignatur" />
                    </clr-checkbox-wrapper>
                  </clr-checkbox-container>
                  <div class="clr-form-control">
                    <label for="select-length" class="clr-control-label" style="min-width: 300px; margin-left: -10px">
                      {{ 'Längeneinheit' | mrTranslate }}
                    </label>
                    <div class="clr-control-container">
                      <div class="clr-select-wrapper">
                        <select id="select-length" class="clr-select" formControlName="optUnitLength">
                          @for (item of lengthUnitItems; track item; let i = $index) {
                            <option [ngValue]="+i">{{ lengthUnitItems[i] }}</option>
                          }
                        </select>
                        <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                      </div>
                    </div>
                  </div>
                  <div class="clr-form-control">
                    <label for="select-width" class="clr-control-label" style="min-width: 300px; margin-left: -10px">
                      {{ 'Einheit Messwerte' | mrTranslate }}
                    </label>
                    <div class="clr-control-container">
                      <div class="clr-select-wrapper">
                        <select id="select-width" class="clr-select" formControlName="optUnitWidth">
                          @for (item of measurementUnitItems; track item; let i = $index) {
                            <option [ngValue]="+i">{{ measurementUnitItems[i] }}</option>
                          }
                        </select>
                        <cds-icon class="clr-validate-icon" shape="exclamation-circle" />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Anmeldung' | mrTranslate }}</strong>
                <div class="clr-col-8" style="margin-top: -15px">
                  <clr-radio-container clrInline>
                    <label style="display: table">{{ 'Authentifizierung' | mrTranslate }}</label>
                    <clr-radio-wrapper>
                      <input
                        type="radio"
                        clrRadio
                        formControlName="optAuthentType"
                        [value]="0"
                        (change)="onAnmeldChanged($event, 'mrpro')" />
                      <label>{{ 'MR.pro®' }}</label>
                    </clr-radio-wrapper>
                    <clr-radio-wrapper>
                      <input
                        type="radio"
                        clrRadio
                        formControlName="optAuthentType"
                        [value]="2"
                        (change)="onAnmeldChanged($event, 'msal')" />
                      <label>{{ 'AzureAd' }}</label>
                    </clr-radio-wrapper>
                  </clr-radio-container>
                  @if (optAuthentType == 0) {
                    <br />
                    <clr-checkbox-container class="margin-0-t">
                      <clr-checkbox-wrapper>
                        <label>
                          {{ '2‑Faktor-Authentifizierung mit Google Authenticator' | mrTranslate }}
                        </label>
                        <input clrCheckbox type="checkbox" formControlName="tfa" (change)="changeStatus($event)" />
                      </clr-checkbox-wrapper>
                    </clr-checkbox-container>
                  }
                  @if (optAuthentType == 2) {
                    <clr-input-container>
                      <label style="margin-left: 10px">
                        {{ 'App Id' | mrTranslate }}
                      </label>
                      <input
                        clrInput
                        placeholder="App Id"
                        name="ADAppid"
                        formControlName="ADAppid"
                        style="min-width: 350px" />
                    </clr-input-container>
                    <clr-input-container>
                      <label style="margin-left: 10px">
                        {{ 'Tenant' | mrTranslate }}
                      </label>
                      <input
                        clrInput
                        placeholder="Tenant"
                        name="ADTenant"
                        formControlName="ADTenant"
                        style="min-width: 350px" />
                    </clr-input-container>
                  }
                  <br />
                </div>
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <strong>{{ 'Werksabnahme' | mrTranslate }}</strong>
                <div class="clr-col-6">
                  <clr-toggle-wrapper>
                    <input type="checkbox" clrToggle value="false" formControlName="optUseFAT" />
                    <label>{{ 'Werksabnahme aktivieren' | mrTranslate }}</label>
                  </clr-toggle-wrapper>
                </div>
              </form>
              <hr />
              <form clrForm [formGroup]="optionGroup">
                <div class="clr-col-4">
                  <button
                    class="btn btn-primary btn-sm margin-20-t"
                    type="submit"
                    [disabled]="trial"
                    (click)="saveINI()">
                    {{ 'Speichern' | mrTranslate }}
                  </button>
                </div>
              </form>
            </div>
          }
          @case ('bezeichnungen') {
            <div>
              <form clrForm>
                <clr-datagrid class="datagrid-compact">
                  <clr-dg-column>{{ 'Feld' | mrTranslate }}</clr-dg-column>
                  <clr-dg-column>{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
                  <clr-dg-column>{{ 'Anzeigen' | mrTranslate }}</clr-dg-column>
                  <clr-dg-column>{{ 'Pflichtfeld' | mrTranslate }}</clr-dg-column>

                  <clr-dg-row *clrDgItems="let item of kundenbezeichnung.rows" [clrDgItem]="item">
                    <clr-dg-cell>
                      @if (item.FeldName == 'Eigentuemer') {
                        {{ 'Eigentümer' | mrTranslate }}
                      } @else if (item.FeldName.startsWith('KNField')) {
                        {{ replaceKundenfeld(item.FeldName) }}
                      } @else {
                        {{ item.FeldName | mrTranslate }}
                      }
                    </clr-dg-cell>
                    <clr-dg-cell>{{ item.KBezeichnung | dotDotDot: 30 }}</clr-dg-cell>
                    <clr-dg-cell><app-dg-cell [data]="item.KShow" /></clr-dg-cell>
                    <clr-dg-cell><app-dg-cell [data]="item.KPflicht" /></clr-dg-cell>
                  </clr-dg-row>
                  <clr-dg-detail *clrIfDetail="let detail">
                    <clr-dg-detail-header>
                      {{ detail.FeldName | mrTranslate }}
                    </clr-dg-detail-header>
                    <clr-dg-detail-body>
                      <clr-input-container style="margin-left: 3px">
                        <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                        <input clrInput type="text" value="{{ detail.KBezeichnung }}" #bez />
                      </clr-input-container>
                      <br />
                      <clr-checkbox-container class="margin-0-t">
                        <clr-checkbox-wrapper>
                          <label>{{ 'Anzeigen' | mrTranslate }}</label>
                          <input type="checkbox" clrCheckbox [checked]="detail.KShow == true" #show />
                        </clr-checkbox-wrapper>
                      </clr-checkbox-container>
                      <br />
                      <clr-checkbox-container class="margin-0-t">
                        <clr-checkbox-wrapper>
                          <label>{{ 'Pflichtfeld' | mrTranslate }}</label>
                          <input type="checkbox" clrCheckbox [checked]="detail.KPflicht == true" #must />
                        </clr-checkbox-wrapper>
                      </clr-checkbox-container>
                      <br />
                      <br />
                      <div class="clr-row">
                        <div class="clr-col">
                          <button class="btn btn-primary" type="submit" (click)="saveBezeichnung(detail.ID)">
                            {{ 'Speichern' | mrTranslate }}
                          </button>
                        </div>
                      </div>
                    </clr-dg-detail-body>
                  </clr-dg-detail>
                </clr-datagrid>
              </form>
            </div>
          }
          @case ('gismap') {
            <div>
              <form clrForm style="height: 680px">
                <clr-input-container>
                  <label>{{ 'Bing' }}</label>
                  <input clrInput placeholder="Bing-API-Key" name="bing" [(ngModel)]="apiKeys.bing" />
                </clr-input-container>
                <clr-input-container>
                  <label>{{ 'Mapbox' }}</label>
                  <input clrInput placeholder="Mapbox-API-Key" name="mapbox" [(ngModel)]="apiKeys.mapbox" />
                </clr-input-container>
                <button
                  class="btn btn-primary btn-sm margin-20-t"
                  type="submit"
                  [disabled]="trial"
                  (click)="saveApiKeys()">
                  {{ 'Speichern' | mrTranslate }}
                </button>
              </form>
            </div>
          }
          @case ('kav') {
            <div>
              <div class="clr-row">
                <div class="clr-col">
                  <form clrForm id="kavForm" [formGroup]="kavGroup">
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>
                        {{ ('Gleis' | mrTranslate) + ': ' + ('Wichtung offener Oberbau' | mrTranslate) }}
                      </h5>
                    </div>
                    <div class="d-f w-100-p">
                      <div style="min-width: 45%">
                        <clr-input-container class="margin-0-t">
                          <label>{{ 'Schiene' | mrTranslate }}</label>
                          <input clrInput type="number" formControlName="gleisOffenerOberbauSchiene" />
                        </clr-input-container>
                        <clr-input-container>
                          <label>{{ 'Schwellen' | mrTranslate }}</label>
                          <input clrInput type="number" formControlName="gleisOffenerOberbauSchwellen" />
                        </clr-input-container>
                        <clr-input-container>
                          <label>{{ 'Befestigung' | mrTranslate }}</label>
                          <input clrInput type="number" formControlName="gleisOffenerOberbauBefestigung" />
                        </clr-input-container>
                      </div>
                      <div style="min-width: 45%">
                        <clr-input-container class="margin-0-t">
                          <label>{{ 'Bettung' | mrTranslate }}</label>
                          <input clrInput type="number" formControlName="gleisOffenerOberbauBettung" />
                        </clr-input-container>
                        <clr-input-container>
                          <label>{{ 'Unterbau' | mrTranslate }}</label>
                          <input clrInput type="number" formControlName="gleisOffenerOberbauUnterbau" />
                        </clr-input-container>
                      </div>
                      <div style="max-width: 10%">
                        <p class="text-center">
                          {{ 'Summe' | mrTranslate }}
                          <br />
                          <span
                            class="badge"
                            [ngClass]="getSum('gleisOffenerOberbau') > 1 ? 'badge-danger' : 'badge-blue'">
                            {{ getSum('gleisOffenerOberbau') }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>
                        {{ ('Gleis' | mrTranslate) + ': ' + ('Wichtung geschlossener Oberbau' | mrTranslate) }}
                      </h5>
                    </div>
                    <div class="d-f w-100-p">
                      <div style="min-width: 45%">
                        <clr-number-input-container class="margin-0-t">
                          <label>{{ 'Schiene' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauSchiene" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Schwelle/Tragschicht' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauSchwellen" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Befestigung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauBefestigung" />
                        </clr-number-input-container>
                      </div>
                      <div style="min-width: 45%">
                        <clr-number-input-container class="margin-0-t">
                          <label>{{ 'Bettung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauBettung" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Unterbau' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauUnterbau" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Eindeckung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="gleisGeschlossenerOberbauEindeckung" />
                        </clr-number-input-container>
                      </div>
                      <div style="max-width: 10%">
                        <p class="text-center">
                          {{ 'Summe' | mrTranslate }}
                          <br />
                          <span
                            class="badge"
                            [ngClass]="getSum('gleisGeschlossenerOberbau') > 1 ? 'badge-danger' : 'badge-blue'">
                            {{ getSum('gleisGeschlossenerOberbau') }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Weichen: Wichtung' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p">
                      <div style="min-width: 45%">
                        <clr-number-input-container class="margin-0-t">
                          <label>{{ 'Schiene' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenSchiene" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Schwelle/Tragschicht' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenSchwellen" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Befestigung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenBefestigung" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Bettung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenBettung" />
                        </clr-number-input-container>
                      </div>
                      <div style="min-width: 45%">
                        <clr-number-input-container class="margin-0-t">
                          <label>{{ 'Unterbau' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenUnterbau" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Zungenvorrichtung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenZungenvorrichtung" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Herzstück' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenHerzstück" />
                        </clr-number-input-container>
                        <clr-number-input-container>
                          <label>{{ 'Eindeckung' | mrTranslate }}</label>
                          <input clrNumberInput type="number" formControlName="weichenEindeckung" />
                        </clr-number-input-container>
                      </div>
                      <div style="max-width: 10%">
                        <p class="text-center">
                          {{ 'Summe' | mrTranslate }}
                          <br />
                          <span class="badge" [ngClass]="getSum('weichen') > 1 ? 'badge-danger' : 'badge-blue'">
                            {{ getSum('weichen') }}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Schwellenbewertung' | mrTranslate }}</h5>
                    </div>
                    @if (kavSettings != {} && kavSettings.schwellen) {
                      <div class="d-f w-100-p margin--12-l margin-7-b">
                        <table class="table table-compact margin-0-t editableTable" style="max-width: 50%">
                          <thead>
                            <tr>
                              <th class="left">{{ 'Schwellenart' | mrTranslate }}</th>
                              <th class="left">{{ 'max Liegedauer' | mrTranslate }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (schwelle of kavSettings.schwellen; track schwelle) {
                              <tr>
                                <td class="left">{{ schwelle.Schwellenart }}</td>
                                <td class="left">
                                  <clr-number-input-container>
                                    <input
                                      clrNumberInput
                                      type="number"
                                      [(ngModel)]="schwelle['max. Liegedauer']"
                                      [ngModelOptions]="{ standalone: true }" />
                                  </clr-number-input-container>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    }
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Schwellenhöhenbewertung' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <table class="table table-compact margin-0-t editableTable" style="max-width: 60%">
                        <thead>
                          <tr>
                            <th class="left">{{ 'Schienenform' | mrTranslate }}</th>
                            <th class="left">{{ 'Schienenhöhe' | mrTranslate }}</th>
                            <th class="left">{{ 'max Höhenverschleiß' | mrTranslate }}</th>
                          </tr>
                        </thead>
                        @if (kavSettings.schienenhoehe) {
                          <tbody>
                            @for (schiene of kavSettings.schienenhoehe; track schiene) {
                              <tr>
                                <td class="left">{{ schiene.Schienenform }}</td>
                                <td class="left">
                                  <clr-number-input-container>
                                    <input
                                      clrNumberInput
                                      type="number"
                                      [(ngModel)]="schiene['Schienenhöhe']"
                                      [ngModelOptions]="{ standalone: true }" />
                                  </clr-number-input-container>
                                </td>
                                <td class="left">
                                  <clr-number-input-container>
                                    <input
                                      clrNumberInput
                                      type="number"
                                      [(ngModel)]="schiene['max. Höhenverschleiß']"
                                      [ngModelOptions]="{ standalone: true }" />
                                  </clr-number-input-container>
                                </td>
                              </tr>
                            }
                          </tbody>
                        }
                      </table>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Grenzwert für Anlagenklassen' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <table class="table table-compact margin-0-t editableTable" style="max-width: 70%">
                        <thead>
                          <tr>
                            <th class="left">{{ 'Anlagenklasse' | mrTranslate }}</th>
                            <th class="left">{{ 'Kategorie 3' | mrTranslate }}</th>
                            <th class="left">{{ 'Kategorie 2' | mrTranslate }}</th>
                            <th class="left">{{ 'Kategorie 1' | mrTranslate }}</th>
                            <th class="left">{{ 'geplante Nutzung' | mrTranslate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (anlage of kavSettings.anlagenklasse; track anlage) {
                            <tr>
                              <td class="left">{{ anlage.ak }}</td>
                              <td class="left">
                                <clr-number-input-container>
                                  <input
                                    clrNumberInput
                                    type="number"
                                    [(ngModel)]="anlage['Kat3']"
                                    [ngModelOptions]="{ standalone: true }" 
                                    style="max-width: 80px;"/>
                                </clr-number-input-container>
                              </td>
                              <td class="left">
                                <clr-number-input-container>
                                  <input
                                    clrNumberInput
                                    type="number"
                                    [(ngModel)]="anlage['Kat2']"
                                    [ngModelOptions]="{ standalone: true }"
                                    style="max-width: 80px;"/>
                                </clr-number-input-container>
                              </td>
                              <td class="left">
                                <clr-number-input-container>
                                  <input
                                    clrNumberInput
                                    type="number"
                                    [(ngModel)]="anlage['Kat1']"
                                    [ngModelOptions]="{ standalone: true }"
                                    style="max-width: 80px;" />
                                </clr-number-input-container>
                              </td>
                              <td class="left">
                                <clr-number-input-container>
                                  <input
                                    clrNumberInput
                                    type="number"
                                    [(ngModel)]="anlage['DNutzung']"
                                    [ngModelOptions]="{ standalone: true }"
                                    style="max-width: 80px;" />
                                </clr-number-input-container>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Farbverwaltung Anlagenklassen' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b" style="flex-direction: column">
                      <div class="d-f">
                        <input type="color" style="display: none" formControlName="kavKat1Color" #colorIn />
                        <cds-icon
                          shape="circle"
                          solid="true"
                          class="cursor-pointer"
                          [ngStyle]="{ color: kavGroup.value.kavKat1Color }"
                          (click)="colorFocusInput(colorIn)"></cds-icon>
                        <span class="margin--3-t margin-3-l">
                          {{ ('Kategorie' | mrTranslate) + ' 1' }}
                        </span>
                      </div>
                      <div class="d-f margin-10-t">
                        <input type="color" style="display: none" formControlName="kavKat2Color" #colorIn2 />
                        <cds-icon
                          shape="circle"
                          solid="true"
                          class="cursor-pointer"
                          [ngStyle]="{ color: kavGroup.value.kavKat2Color }"
                          (click)="colorFocusInput(colorIn2)"></cds-icon>
                        <span class="margin--3-t margin-3-l">
                          {{ ('Kategorie' | mrTranslate) + ' 2' }}
                        </span>
                      </div>
                      <div class="d-f margin-10-t">
                        <input type="color" style="display: none" formControlName="kavKat3Color" #colorIn3 />
                        <cds-icon
                          shape="circle"
                          solid="true"
                          class="cursor-pointer"
                          [ngStyle]="{ color: kavGroup.value.kavKat3Color }"
                          (click)="colorFocusInput(colorIn3)"></cds-icon>
                        <span class="margin--3-t margin-3-l">
                          {{ ('Kategorie' | mrTranslate) + ' 3' }}
                        </span>
                      </div>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Anzeigeoptionen' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <div style="min-width: 30%">
                        <clr-checkbox-container class="margin-0-t">
                          <clr-checkbox-wrapper>
                            <label>{{ 'KAV anzeigen' | mrTranslate }}</label>
                            <input type="checkbox" clrCheckbox formControlName="anzeigeKAV" />
                          </clr-checkbox-wrapper>
                        </clr-checkbox-container>
                      </div>
                      <div style="min-width: 30%">
                        <clr-checkbox-container class="margin-0-t">
                          <clr-checkbox-wrapper>
                            <label>{{ 'KAV in Dok schreiben' | mrTranslate }}</label>
                            <input type="checkbox" clrCheckbox formControlName="anzeigeKAVDok" />
                          </clr-checkbox-wrapper>
                        </clr-checkbox-container>
                      </div>
                    </div>

                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Anzeigetyp' | mrTranslate }}</h5>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                        <div style="min-width: 40%">
                        <clr-radio-container clrInline class="margin-0-t">
                          <clr-radio-wrapper>
                            <input type="radio" clrRadio formControlName="anzeigeTyp" [value]="0" />
                            <label>{{ 'KAV' | mrTranslate }}</label>
                          </clr-radio-wrapper>
                          <clr-radio-wrapper>
                            <input type="radio" clrRadio formControlName="anzeigeTyp" [value]="1" />
                            <label>{{ 'SAX' }}</label>
                          </clr-radio-wrapper>
                        </clr-radio-container>
                      </div>
                    </div>
                    <div class="d-f w-100-p margin--12-l margin-7-b">
                      <h5>{{ 'Qualitäts-Index' | mrTranslate }} {{'(QI)'}}</h5>
                    </div>

                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                      <div class="clr-col-10">
                        <clr-toggle-container style="margin-top: 0px; margin-left: -22px;">
                          <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle formControlName="useQI" (change)="onUseQIChanged($event)"/>
                            <label>{{ 'QI anwenden' | mrTranslate }}</label>
                          </clr-toggle-wrapper>
                        </clr-toggle-container>
                      </div>
                      
                      @if(useQI){                
                        <div class="clr-col-1">
                          <div class="btn-group btn-primary btn-icon btn-sm">
                              <button class="btn btn-success"
                              (click)="addQualitaetsindex()"
                              >
                                <clr-icon shape="plus"></clr-icon>
                              </button>
                              <button class="btn btn-danger"
                              [disabled]="selectedQI.length===0"
                              (click)="deleteualitaetsindex()"
                              >
                                <clr-icon shape="times"></clr-icon>
                              </button>
                          </div>
                        </div>
                      }
                    </div>

                    @if(useQI){
                      @if (Qualitaetsindex?.columns) {
                        <clr-datagrid class="datagrid-compact"
                          [(clrDgSelected)]="selectedQI"
                          [clrDgSelectionType]="'single'"
                          [clrDgItemsIdentityFn]="trackQIById"
                        >

                          @for (column of Qualitaetsindex.columns; track column) {
                            <clr-dg-column [clrDgField]="column.id">
                              <ng-container
                                *clrDgHideableColumn="{
                                  hidden: column.id | hideIDColumns: ['typ', 'Profiltyp', 'SchHMax', 'BildBase64', 'Profil'],
                                }">
                                {{ column.id | mrTranslate | titlecase }}
                              </ng-container>
                            </clr-dg-column>
                          }
                          <clr-dg-row *clrDgItems="let row of Qualitaetsindex.rows; let i = index" [clrDgItem]="row">
                            @for (cell of Qualitaetsindex.columns; track cell) {

                              @if(cell.id == 'Farbe'){
                                <clr-dg-cell class="name-cell">
                                  <span class="color-square" [ngStyle]="{ 'background-color': row[cell.id] }"></span>
                                </clr-dg-cell>
                              }
                              @else {
                                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                              }
                              
                            }
                          </clr-dg-row>

                          <ng-template [(clrIfDetail)]="stateQI" let-detail (clrIfDetailChange)="onDetailQI($event)">
                            <clr-dg-detail>
                                <clr-dg-detail-body>
                                  <form clrForm [formGroup]="QI">
                                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                                      <div class="clr-col-3">
                                        {{ 'Note' | mrTranslate }}
                                      </div>
                                      <div class="clr-col-3">
                                        <input type="number" class="clr-input" formControlName="index" />
                                      </div>
                                    </div>
                                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                                      <div class="clr-col-3">
                                        {{ 'von' | mrTranslate }}
                                      </div>
                                      <div class="clr-col-3">
                                        <input type="number" class="clr-input" formControlName="von" />
                                      </div>
                                    </div>
                                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                                      <div class="clr-col-3">
                                        {{ 'bis' | mrTranslate }}
                                      </div>
                                      <div class="clr-col-3">
                                        <input type="number" class="clr-input" formControlName="bis" />
                                      </div>
                                    </div>
                                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                                      <div class="clr-col-3">
                                        {{ 'Beschreibung' | mrTranslate }}
                                      </div>
                                      <div class="clr-col-3">
                                        <input type="text" class="clr-input" formControlName="beschreibung" />
                                      </div>
                                    </div>
                                    <div class="clr-row" style="min-height: 30px;height: 35px;">
                                      <div class="clr-col-3">
                                        {{ 'Farbe' | mrTranslate }}
                                      </div>
                                      <div class="clr-col-3">
                                        <span class="color-square" [ngStyle]="{ 'background-color': QIColor }" (click)="colorPicker.click()" style="cursor: pointer;"></span>
                                        
                                      </div>
                                    </div>

                                    <input
                                      #colorPicker
                                      type="color"
                                      [value]="QIColor"
                                      (input)="onColorChange($event)"
                                      hidden>


                                    <br/>
                                    <div class="clr-row">
                                      <div class="clr-col">
                                        <button class="btn btn-primary" type="submit" [disabled]="trial" (click)="saveQISettings()">
                                          {{ 'Speichern' | mrTranslate }}
                                        </button>
                                      </div>
                                    </div>

                                  </form>

                                </clr-dg-detail-body>
                              </clr-dg-detail>
                          </ng-template>

                        </clr-datagrid>
                      }
                    }
                    <br/>
                  </form>
                </div>
              </div>
              <div class="clr-row">
                <div class="clr-col">
                  <button class="btn btn-primary" type="submit" [disabled]="trial" (click)="saveKAVSettings()">
                    {{ 'Speichern' | mrTranslate }}
                  </button>
                </div>
              </div>
            </div>
          }
          @case ('interface') {
            <div>
              <div class="clr-row">
                <div class="clr-col">
                  <form
                    clrForm
                    [formGroup]="interfaceGroup"
                    [style]="_optExportFormat != -1 ? 'min-height: 0px' : 'min-height: 700px'">
                    <h5 style="margin-top: -5px">
                      {{ 'Schnittstellenformat' | mrTranslate }}
                    </h5>
                    <clr-radio-container clrInline style="margin-top: 5px">
                      <clr-radio-wrapper>
                        <input
                          type="radio"
                          clrRadio
                          formControlName="optExportFormat"
                          [value]="-1"
                          (change)="onInterfaceChanged($event, 'keine')" />
                        <label>{{ 'keine' | mrTranslate }}</label>
                      </clr-radio-wrapper>
                      <clr-radio-wrapper>
                        <input
                          type="radio"
                          clrRadio
                          formControlName="optExportFormat"
                          [value]="1"
                          (change)="onInterfaceChanged($event, 'SAP')" />
                        <label>{{ 'SAP' }}</label>
                      </clr-radio-wrapper>
                      <clr-radio-wrapper>
                        <input
                          type="radio"
                          clrRadio
                          formControlName="optExportFormat"
                          [value]="2"
                          (change)="onInterfaceChanged($event, 'INFRALIFE')" />
                        <label>{{ 'INFRALIFE' }}</label>
                      </clr-radio-wrapper>
                      <clr-radio-wrapper>
                        <input
                          type="radio"
                          clrRadio
                          formControlName="optExportFormat"
                          [value]="3"
                          (change)="onInterfaceChanged($event, 'HxGN EAM')" />
                        <label>{{ 'HxGN EAM' }}</label>
                      </clr-radio-wrapper>
                      <clr-radio-wrapper>
                        <input
                          type="radio"
                          clrRadio
                          formControlName="optExportFormat"
                          [value]="0"
                          (change)="onInterfaceChanged($event, 'ZEDAS')" />
                        <label>{{ 'ZEDAS' }}</label>
                      </clr-radio-wrapper>
                    </clr-radio-container>
                    <br />
                    @if (_optExportFormat != -1) {
                      <div>
                        <!-- <hr style="margin-top: -5px;"> -->
                        <h5 style="margin-top: 0px">{{ 'Anmeldung' | mrTranslate }}</h5>
                        <!-- <div style="height: 15px;"></div> -->
                        <clr-input-container style="margin-top: 5px">
                          <label style="margin-left: 12px">
                            {{ 'Benutzername' | mrTranslate }}
                          </label>
                          <input
                            id="username"
                            type="text"
                            clrInput
                            name="username"
                            required
                            formControlName="username"
                            style="width: 300px" />
                          <clr-control-error>{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                        </clr-input-container>
                        <clr-password-container>
                          <label>{{ 'Passwort' | mrTranslate }}</label>
                          <input
                            id="passwort"
                            type="text"
                            clrPassword
                            name="passwort"
                            required
                            formControlName="passwort"
                            style="width: 300px" />
                          <clr-control-error>{{ 'Erforderlich' | mrTranslate }}</clr-control-error>
                        </clr-password-container>
                        <br />
                        <!-- <hr style="margin-top: -5px;"> -->
                        <h5 style="margin-top: 0px">{{ 'URL' | mrTranslate }}</h5>
                        @if (_optExportFormat != 0 && _optExportFormat != 2) {
                          <div>
                            <clr-input-container style="margin-top: 5px">
                              <label style="margin-left: 12px">
                                {{ labelLogin | mrTranslate }}
                              </label>
                              <input
                                style="width: 800px"
                                id="urllogin"
                                type="text"
                                clrInput
                                name="urllogin"
                                formControlName="urllogin" />
                            </clr-input-container>
                          </div>
                        }
                        @if (_optExportFormat != 3) {
                          <clr-input-container>
                            <label style="margin-left: 12px; min-width: 300px">
                              {{ 'Mängel übertragen' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlmangel"
                              type="text"
                              clrInput
                              name="urlmangel"
                              formControlName="urlmangel" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 0 || _optExportFormat == 2) {
                          <clr-input-container>
                            <label style="margin-left: 12px; min-width: 300px">
                              {{ 'Messungen übertragen' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlmess"
                              type="text"
                              clrInput
                              name="urlmess"
                              formControlName="urlmess" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1 || _optExportFormat == 3) {
                          <clr-input-container>
                            <label style="margin-left: 12px">
                              {{ labelAuftrag | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlauftrag"
                              type="text"
                              clrInput
                              name="urlauftrag"
                              formControlName="urlauftrag" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1 || _optExportFormat == 2) {
                          <clr-input-container>
                            <label style="margin-left: 12px">
                              {{ 'Status abfragen' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlstatus"
                              type="text"
                              clrInput
                              name="urlmangel"
                              formControlName="urlstatus" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1) {
                          <clr-input-container>
                            <label style="margin-left: 12px">
                              {{ 'zeige Mangel' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlshowmangel"
                              type="text"
                              clrInput
                              name="urlmangel"
                              formControlName="urlshowmangel" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1) {
                          <clr-input-container>
                            <label style="margin-left: 12px">
                              {{ 'zeige Auftrag' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlshowauftrag"
                              type="text"
                              clrInput
                              name="urlmangel"
                              formControlName="urlshowauftrag" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1 || _optExportFormat == 2) {
                          <clr-input-container>
                            <label style="margin-left: 12px">
                              {{ 'Stammdaten abgleichen' | mrTranslate }}
                            </label>
                            <input
                              style="width: 800px"
                              id="urlmergestamm"
                              type="text"
                              clrInput
                              name="urlmangel"
                              formControlName="urlmergestamm" />
                          </clr-input-container>
                        }
                        @if (_optExportFormat == 1) {
                          <div>
                            <br />
                            <h5 style="margin-top: 0px">
                              {{ 'Filterregeln' | mrTranslate }}
                            </h5>
                            <clr-radio-container clrInline style="margin-top: 5px">
                              <clr-radio-wrapper>
                                <input
                                  type="radio"
                                  clrRadio
                                  formControlName="optExportFilter"
                                  [value]="0"
                                  (change)="onInterfaceFilterChanged($event, 'all')" />
                                <label>
                                  {{ 'Alle Mängel exportieren' | mrTranslate }}
                                </label>
                              </clr-radio-wrapper>
                              <clr-radio-wrapper>
                                <input
                                  type="radio"
                                  clrRadio
                                  formControlName="optExportFilter"
                                  [value]="1"
                                  (change)="onInterfaceFilterChanged($event, 'filter')" />
                                <label>
                                  {{ 'mit Filterregeln' | mrTranslate }}
                                </label>
                              </clr-radio-wrapper>
                            </clr-radio-container>
                            @if (_optExportFilter == 1) {
                              <div>
                                <clr-checkbox-container clrInline>
                                  <label>{{ 'Fehlerklassen' | mrTranslate }}</label>

                                  <clr-checkbox-wrapper *ngFor="let key of fehlerklassen">
                                    <input
                                      clrCheckbox
                                      type="checkbox"
                                      [checked]="fkMap[key]"
                                      (change)="onCheckboxChange(key, $any($event.target).checked)" />

                                    <label>{{ key }}</label>
                                  </clr-checkbox-wrapper>
                                </clr-checkbox-container>
                                <br />
                                <span>
                                  {{
                                    'Es werden alle Mängel exportiert, die nicht folgendnen Regeln unterliegen.'
                                      | mrTranslate
                                  }}
                                </span>
                                <div class="clr-row nxm" style="margin-top: 10px">
                                  <div class="clr-col-2">
                                    <label>{{ 'Filterregel' | mrTranslate }}</label>
                                  </div>
                                  <div class="clr-col-1">
                                    <label>{{ 'Regel' | mrTranslate }}</label>
                                  </div>
                                  <div class="clr-col-6">
                                    <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                                  </div>
                                </div>
                                <div class="clr-row nxm" style="margin-top: 10px">
                                  <div class="clr-col-2">
                                    <clr-select-container style="margin-top: 0px; margin-left: -20px">
                                      <select
                                        clrSelect
                                        (change)="onFilterregelChange($event.target)"
                                        formControlName="regelart">
                                        <option value="0">{{ 'Instandsetzung' | mrTranslate }}</option>
                                        <option value="1">{{ 'Mangel' | mrTranslate }}</option>
                                        <option value="2">{{ 'Prüfart' | mrTranslate }}</option>
                                      </select>
                                    </clr-select-container>
                                  </div>
                                  <div class="clr-col-1">
                                    <clr-select-container style="margin-top: 0px">
                                      <select clrSelect formControlName="regel">
                                        <option value="=">=</option>
                                        <option value="enthält">{{ 'enthält' | mrTranslate }}</option>
                                      </select>
                                    </clr-select-container>
                                  </div>
                                  <div class="clr-col-6">
                                    <clr-datalist-container style="margin-top: -7px; margin-left: 5px">
                                      <input
                                        clrDatalistInput
                                        type="search"
                                        autocomplete="off"
                                        name="pruefart"
                                        style="width: 400px"
                                        formControlName="regelwert" />
                                      <datalist>
                                        @for (obj of regeln_sel; track obj) {
                                          <option>{{ obj }}</option>
                                        }
                                      </datalist>
                                    </clr-datalist-container>
                                  </div>
                                  <div class="clr-col">
                                    <div class="btn-group btn-primary btn-icon" style="margin-top: -15px">
                                      <button class="btn btn-success" (click)="addRegel()">
                                        <cds-icon shape="file" />
                                        <span class="clr-icon-title">
                                          {{ 'Neu' | mrTranslate }}
                                        </span>
                                      </button>
                                      <button class="btn" (click)="saveRegel()">
                                        <cds-icon shape="floppy" />
                                        <span class="clr-icon-title">
                                          {{ 'Speichern' | mrTranslate }}
                                        </span>
                                      </button>
                                      <button class="btn btn-danger" [disabled]="regelid == 0" (click)="deleteRegel()">
                                        <cds-icon shape="times" />
                                        <span class="clr-icon-title">
                                          {{ 'Löschen' | mrTranslate }}
                                        </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div style="min-height: 10px; height: 10px"></div>
                                @if (regeln!.rows!.length > 0) {
                                  <div class="limit-height">
                                    <clr-datagrid
                                      class="datagrid-compact"
                                      [clrDgSelectionType]="'single'"
                                      [(clrDgSelected)]="selectedRegel"
                                      (clrDgSelectedChange)="selectionRegelChanged($event)"
                                      [clrDgRowSelection]="true"
                                      [clrDgItemsIdentityFn]="trackRegelItemById">
                                      @for (column of regeln.columns; track column) {
                                        <clr-dg-column [clrDgField]="column.id">
                                          <ng-container
                                            *clrDgHideableColumn="{
                                              hidden:
                                                column.id
                                                | hideIDColumns
                                                  : [
                                                      'TypID',
                                                      'profiltyp',
                                                      'schhmax',
                                                      'bildbase64',
                                                      'profil',
                                                      'anweisungbase64',
                                                    ],
                                            }">
                                            {{ column.id | mrTranslate }}
                                          </ng-container>
                                        </clr-dg-column>
                                      }
                                      <clr-dg-row
                                        *clrDgItems="let row of regeln.rows; trackBy: trackById"
                                        [clrDgItem]="row">
                                        @for (cell of regeln.columns; track cell) {
                                          <clr-dg-cell>
                                            <app-dg-cell [data]="row[cell.id]" [col]="cell.id" />
                                          </clr-dg-cell>
                                        }
                                      </clr-dg-row>
                                      <clr-dg-footer>
                                        {{ regeln.rows?.length }} {{ 'Regeln' | mrTranslate }}
                                      </clr-dg-footer>
                                    </clr-datagrid>
                                  </div>
                                }
                              </div>
                            }
                            @if (_optExportFormat == 1) {
                              <div>
                                <br />
                                <h5 style="margin-top: 0px">{{ 'Meldungsarten' | mrTranslate }}</h5>
                                <clr-datagrid class="datagrid-compact" style="width: 852px">
                                  <clr-dg-column>{{ 'Fehlerklasse' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-column>{{ 'SAP Priorität' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-column>{{ 'Medungsart' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-column>{{ 'Leistungsart' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-column>{{ 'Instandhaltungsfrist' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-column>{{ 'Intervall' | mrTranslate }}</clr-dg-column>
                                  <clr-dg-row>
                                    <clr-dg-cell>1</clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput style="max-width: 80px" formControlName="proi1" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput style="max-width: 80px" formControlName="mart1" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput style="max-width: 80px" formControlName="lart1" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input
                                        clrInput
                                        min="1"
                                        type="number"
                                        style="max-width: 80px"
                                        formControlName="frist1" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <select
                                        clrSelect
                                        name="options"
                                        formControlName="intervall1"
                                        style="margin-top: 0px">
                                        <option value="Stunden">{{ 'Stunden' | mrTranslate }}</option>
                                        <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
                                        <option value="Woche">{{ 'Woche' | mrTranslate }}</option>
                                        <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
                                      </select>
                                    </clr-dg-cell>
                                  </clr-dg-row>
                                  <clr-dg-row>
                                    <clr-dg-cell>2</clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="proi2" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="mart2" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="lart2" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input
                                        clrInput
                                        min="1"
                                        type="number"
                                        name="input"
                                        style="max-width: 80px"
                                        formControlName="frist2" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <select
                                        clrSelect
                                        name="options2"
                                        formControlName="intervall2"
                                        style="margin-top: 0px">
                                        <option value="Stunden">{{ 'Stunden' | mrTranslate }}</option>
                                        <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
                                        <option value="Woche">{{ 'Woche' | mrTranslate }}</option>
                                        <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
                                      </select>
                                    </clr-dg-cell>
                                  </clr-dg-row>
                                  <clr-dg-row>
                                    <clr-dg-cell>3</clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="proi3" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="mart3" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="lart3" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input
                                        clrInput
                                        min="1"
                                        type="number"
                                        name="input"
                                        style="max-width: 80px"
                                        formControlName="frist3" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <select
                                        clrSelect
                                        name="options3"
                                        formControlName="intervall3"
                                        style="margin-top: 0px">
                                        <option value="Stunden">{{ 'Stunden' | mrTranslate }}</option>
                                        <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
                                        <option value="Woche">{{ 'Woche' | mrTranslate }}</option>
                                        <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
                                      </select>
                                    </clr-dg-cell>
                                  </clr-dg-row>
                                  <clr-dg-row>
                                    <clr-dg-cell>4</clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="proi4" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="mart4" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input clrInput name="input" style="max-width: 80px" formControlName="lart4" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <input
                                        clrInput
                                        min="1"
                                        type="number"
                                        name="input"
                                        style="max-width: 80px"
                                        formControlName="frist4" />
                                    </clr-dg-cell>
                                    <clr-dg-cell>
                                      <select
                                        clrSelect
                                        name="options4"
                                        formControlName="intervall4"
                                        style="margin-top: 0px">
                                        <option value="Stunden">{{ 'Stunden' | mrTranslate }}</option>
                                        <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
                                        <option value="Woche">{{ 'Woche' | mrTranslate }}</option>
                                        <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
                                      </select>
                                    </clr-dg-cell>
                                  </clr-dg-row>
                                </clr-datagrid>
                                <br />
                                <h5 style="margin-top: 0px">
                                  {{ 'Login zusätzliche Headers' | mrTranslate }}
                                </h5>
                                <clr-radio-container clrInline style="margin-top: 5px">
                                  <clr-radio-wrapper>
                                    <input
                                      type="radio"
                                      clrRadio
                                      formControlName="optExportHeader"
                                      [value]="0"
                                      (change)="onInterfaceHeadersChanged($event, '0')" />
                                    <label>{{ 'nein' | mrTranslate }}</label>
                                  </clr-radio-wrapper>
                                  <clr-radio-wrapper>
                                    <input
                                      type="radio"
                                      clrRadio
                                      formControlName="optExportHeader"
                                      [value]="1"
                                      (change)="onInterfaceHeadersChanged($event, '1')" />
                                    <label>{{ 'ja' | mrTranslate }}</label>
                                  </clr-radio-wrapper>
                                </clr-radio-container>
                                @if (_optExportHeader == 1) {
                                  <div>
                                    <div class="clr-row nxm" style="margin-top: 5px">
                                      <div class="clr-col-3">
                                        <div class="clr-form-control" style="margin-top: 0px">
                                          <label for="basic" class="clr-control-label">
                                            {{ 'Bezeichnung' | mrTranslate }}
                                          </label>
                                          <div class="clr-control-container">
                                            <div class="clr-input-wrapper">
                                              <input
                                                type="text"
                                                id="bez"
                                                class="clr-input"
                                                formControlName="headerBezeichnung" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="clr-col-6">
                                        <div class="clr-form-control" style="margin-top: 0px">
                                          <label for="basic" class="clr-control-label">
                                            {{ 'Wert' | mrTranslate }}
                                          </label>
                                          <div class="clr-control-container">
                                            <div class="clr-input-wrapper">
                                              <input
                                                type="text"
                                                id="wert"
                                                class="clr-input"
                                                style="width: 350px"
                                                formControlName="headerWert" />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="clr-col">
                                        <div class="btn-group btn-primary btn-icon" style="margin-top: 10px">
                                          <button class="btn btn-success" (click)="addHeader()">
                                            <cds-icon shape="file" />
                                            <span class="clr-icon-title">
                                              {{ 'Neu' | mrTranslate }}
                                            </span>
                                          </button>
                                          <button class="btn" (click)="saveHeader()">
                                            <cds-icon shape="floppy" />
                                            <span class="clr-icon-title">
                                              {{ 'Speichern' | mrTranslate }}
                                            </span>
                                          </button>
                                          <button
                                            class="btn btn-danger"
                                            [disabled]="headerid == 0"
                                            (click)="deleteHeader()">
                                            <cds-icon shape="times" />
                                            <span class="clr-icon-title">
                                              {{ 'Löschen' | mrTranslate }}
                                            </span>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    @if (headers.rows.length > 0) {
                                      <div>
                                        <div class="limit-height">
                                          <clr-datagrid
                                            [clrDgSelectionType]="'single'"
                                            [clrDgSelected]="[selectedHeader]"
                                            (clrDgSelectedChange)="
                                              selectedHeader = $event[0]; selectionHeaderChanged($event[0])
                                            "
                                            [clrDgRowSelection]="true"
                                            [clrDgItemsIdentityFn]="trackHeaderItemById">
                                            @for (column of headers.columns; track column) {
                                              <clr-dg-column [clrDgField]="column.id">
                                                <ng-container
                                                  *clrDgHideableColumn="{
                                                    hidden:
                                                      column.id
                                                      | hideIDColumns
                                                        : [
                                                            'TypID',
                                                            'profiltyp',
                                                            'schhmax',
                                                            'bildbase64',
                                                            'profil',
                                                            'anweisungbase64',
                                                          ],
                                                  }">
                                                  {{ column.id | mrTranslate }}
                                                </ng-container>
                                              </clr-dg-column>
                                            }
                                            <clr-dg-row
                                              *clrDgItems="let row of headers.rows; trackBy: trackById"
                                              [clrDgItem]="row">
                                              @for (cell of headers.columns; track cell) {
                                                <clr-dg-cell>
                                                  <app-dg-cell [data]="row[cell.id]" [col]="cell.id" />
                                                </clr-dg-cell>
                                              }
                                            </clr-dg-row>
                                            <clr-dg-footer>{{ headers.rows?.length }} users</clr-dg-footer>
                                          </clr-datagrid>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                                <br />
                                <h5 style="margin-top: 0px">{{ 'Zusatzfelder Inspektion' | mrTranslate }}</h5>
                                <clr-checkbox-container style="margin-top: 0px">
                                  <clr-checkbox-wrapper>
                                    <input type="checkbox" clrCheckbox formControlName="optSAPFieldTermin" />
                                    <label>{{ 'Termin' | mrTranslate }}</label>
                                  </clr-checkbox-wrapper>
                                  <clr-checkbox-wrapper>
                                    <input type="checkbox" clrCheckbox formControlName="optSAPFieldAusfall" />
                                    <label>{{ 'Ausfall' | mrTranslate }}</label>
                                  </clr-checkbox-wrapper>
                                  <clr-checkbox-wrapper>
                                    <input type="checkbox" clrCheckbox formControlName="optSAPFieldEquipment" />
                                    <label>{{ 'Equipment' | mrTranslate }}</label>
                                  </clr-checkbox-wrapper>
                                </clr-checkbox-container>
                              </div>
                            }
                          </div>
                        }
                        <br />
                        <!-- <hr style="margin-top: -5px;"> -->
                        @if (_optExportFormat == 3) {
                          <div>
                            <br />
                            <h5 style="margin-top: 0px">
                              {{ 'Zusatzfelder Auftragserfassung' | mrTranslate }}
                            </h5>
                            <clr-checkbox-container style="margin-top: 0px">
                              <clr-checkbox-wrapper>
                                <input type="checkbox" clrCheckbox formControlName="optHexFieldUrsache" />
                                <label>{{ 'Ursache' | mrTranslate }}</label>
                              </clr-checkbox-wrapper>
                              <clr-checkbox-wrapper>
                                <input type="checkbox" clrCheckbox formControlName="optHexFieldStörgrund" />
                                <label>{{ 'Störgrund' | mrTranslate }}</label>
                              </clr-checkbox-wrapper>
                              <clr-checkbox-wrapper>
                                <input type="checkbox" clrCheckbox formControlName="optHexFieldStörVon" />
                                <label>{{ 'Beginn Störung' | mrTranslate }}</label>
                              </clr-checkbox-wrapper>
                              <clr-checkbox-wrapper>
                                <input type="checkbox" clrCheckbox formControlName="optHexFieldStörBis" />
                                <label>{{ 'Ende Störung' | mrTranslate }}</label>
                              </clr-checkbox-wrapper>
                              <clr-checkbox-wrapper>
                                <input type="checkbox" clrCheckbox formControlName="optHexFieldFestgestellt" />
                                <label>{{ 'Festgestellt von' | mrTranslate }}</label>
                              </clr-checkbox-wrapper>
                            </clr-checkbox-container>
                          </div>
                        }
                        @if (_optExportFormat == 0) {
                          <div>
                            <h5 style="margin-top: 0px">{{ 'Messwerte' | mrTranslate }}</h5>
                            <clr-radio-container clrInline style="margin-top: 5px">
                              <clr-radio-wrapper>
                                <input type="radio" clrRadio formControlName="optzedasmess" [value]="0" />
                                <label>{{ 'Bezeichnung' | mrTranslate }}</label>
                              </clr-radio-wrapper>
                              <clr-radio-wrapper>
                                <input type="radio" clrRadio formControlName="optzedasmess" [value]="1" />
                                <label>{{ 'Code' | mrTranslate }}</label>
                              </clr-radio-wrapper>
                            </clr-radio-container>
                            <br />
                            <h5 style="margin-top: 0px">{{ 'Gattungsart' | mrTranslate }}</h5>
                            <clr-radio-container clrInline style="margin-top: 5px">
                              <clr-radio-wrapper>
                                <input type="radio" clrRadio formControlName="optzedasgatt" [value]="0" />
                                <label>{{ 'Stellwerk' | mrTranslate }}</label>
                              </clr-radio-wrapper>
                              <clr-radio-wrapper>
                                <input type="radio" clrRadio formControlName="optzedasgatt" [value]="1" />
                                <label>{{ 'Bezirk' | mrTranslate }}</label>
                              </clr-radio-wrapper>
                            </clr-radio-container>
                            <br />
                            <h5 style="margin-top: 0px">{{ 'Funktionen' | mrTranslate }}</h5>
                            <clr-button-group
                              class="btn-group btn-outline-primary btn-sm"
                              [clrMenuPosition]="'bottom-right'"
                              style="margin-top: 5px">
                              <clr-button>
                                {{ 'Mangel-Codes bearbeiten' | mrTranslate }}
                              </clr-button>
                            </clr-button-group>
                          </div>
                        }
                        @if (_optExportFormat == 1) {
                          <div>
                            <h5 style="margin-top: 0px">{{ 'Funktionen' | mrTranslate }}</h5>
                            <clr-button-group
                              class="btn-group btn-outline-primary btn-sm"
                              [clrMenuPosition]="'bottom-right'"
                              style="margin-top: 5px">
                              <clr-button>
                                {{ 'Stammdaten abgleichen' | mrTranslate }}
                              </clr-button>
                              <clr-button>
                                {{ 'Meldungen abgleichen' | mrTranslate }}
                              </clr-button>
                              <clr-button
                                [clrLoading]="loadSAPSynchronize"
                                [disabled]="loadSAPSynchronize"
                                (click)="doSAPSynchronize()">
                                {{ 'Meldungen synchronisieren' | mrTranslate }}
                              </clr-button>
                            </clr-button-group>
                            <br />
                          </div>
                        }
                        <br />
                      </div>
                    }

                    @if (isdev() == true && _optExportFormat == 1) {
                      <br />
                      <h5 style="margin-top: 0px">{{ 'Zusatzfelder' | mrTranslate }}</h5>
                      <div class="clr-row align-items-center mb-2" style="min-height: 30px">
                        <div class="clr-col-2">
                          <label>ZField 1:</label>
                        </div>

                        <div class="clr-col-1">
                          <input type="checkbox" clrCheckbox formControlName="optZFeld1Required" />
                        </div>

                        <div class="clr-col">
                          <clr-input-container style="margin-top: -12px">
                            <input clrInput type="text" [placeholder]="'Bezeichung' | mrTranslate" formControlName="optZFeld1Title" />
                          </clr-input-container>
                        </div>
                      </div>

                      <div class="clr-row align-items-center mb-2" style="min-height: 30px">
                        <div class="clr-col-2">
                          <label>ZField 2:</label>
                        </div>

                        <div class="clr-col-1">
                          <input type="checkbox" clrCheckbox formControlName="optZFeld2Required" />
                        </div>

                        <div class="clr-col">
                          <clr-input-container style="margin-top: -12px">
                            <input clrInput type="text" [placeholder]="'Bezeichung' | mrTranslate" formControlName="optZFeld2Title" />
                          </clr-input-container>
                        </div>
                      </div>

                      <div class="clr-row align-items-center mb-2" style="min-height: 30px">
                        <div class="clr-col-2">
                          <label>ZField 3:</label>
                        </div>

                        <div class="clr-col-1">
                          <input type="checkbox" clrCheckbox formControlName="optZFeld3Required" />
                        </div>

                        <div class="clr-col">
                          <clr-input-container style="margin-top: -12px">
                            <input clrInput type="text" [placeholder]="'Bezeichung' | mrTranslate" formControlName="optZFeld3Title" />
                          </clr-input-container>
                        </div>
                      </div>

                      <div class="clr-row align-items-center mb-2" style="min-height: 30px">
                        <div class="clr-col-2">
                          <label>ZField 4:</label>
                        </div>

                        <div class="clr-col-1">
                          <input type="checkbox" clrCheckbox formControlName="optZFeld4Required" />
                        </div>

                        <div class="clr-col">
                          <clr-input-container style="margin-top: -12px">
                            <input clrInput type="text" [placeholder]="'Bezeichung' | mrTranslate" formControlName="optZFeld4Title" />
                          </clr-input-container>
                        </div>
                      </div>

                      <div class="clr-row align-items-center mb-2" style="min-height: 30px">
                        <div class="clr-col-2">
                          <label>ZField 5:</label>
                        </div>

                        <div class="clr-col-1">
                          <input type="checkbox" clrCheckbox formControlName="optZFeld5Required" />
                        </div>

                        <div class="clr-col">
                          <clr-input-container style="margin-top: -12px">
                            <input clrInput type="text" [placeholder]="'Bezeichung' | mrTranslate" formControlName="optZFeld5Title" />
                          </clr-input-container>
                        </div>
                      </div>
                      <br />
                    }
                  </form>
                </div>
              </div>
              @if (_optExportFormat != -1) {
                <div class="clr-row">
                  <div class="clr-col">
                    <button class="btn btn-primary" type="submit" [disabled]="trial" (click)="saveInterfaceSettings()">
                      {{ 'Speichern' | mrTranslate }}
                    </button>
                  </div>
                </div>
              }
              <br />
              @if (_optExportFormat != -1) {
                <div class="clr-row">
                  <br />
                  <div class="clr-col">
                    <div class="clr-row">
                      <h5 style="margin-top: 5px; margin-left: 15px">
                        {{ 'Protokolle' | mrTranslate }}
                      </h5>
                    </div>
                    <div class="clr-row">
                      <clr-button-group
                        class="btn-group btn-outline-primary btn-sm"
                        [clrMenuPosition]="'bottom-right'"
                        style="margin-top: 5px; margin-left: 15px">
                        <clr-button (click)="getLogFiles()">
                          {{ 'laden' | mrTranslate }}
                        </clr-button>
                      </clr-button-group>
                    </div>
                    @if (interfaceLogFiles.length != 0) {
                      <div class="clr-row">
                        <clr-datagrid
                          style="margin-top: 5px; margin-left: 15px; max-height: 500px; width: 100%; min-width: 800px">
                          <clr-dg-column>{{ 'Name' | mrTranslate }}</clr-dg-column>
                          <clr-dg-column>{{ 'Datum' | mrTranslate }}</clr-dg-column>
                          <clr-dg-row *clrDgItems="let file of interfaceLogFiles.rows">
                            <clr-dg-cell>{{ file['Name'] }}</clr-dg-cell>
                            <clr-dg-cell>{{ file['Datum'] }}</clr-dg-cell>
                            <clr-dg-row-detail *clrIfExpanded>
                              <div class="application-xml" [innerText]="gethtmlData(file['base64'])"></div>
                            </clr-dg-row-detail>
                          </clr-dg-row>
                          <clr-dg-footer>
                            {{ interfaceLogFiles.rows.length }} {{ 'Dateien' | mrTranslate }}
                          </clr-dg-footer>
                        </clr-datagrid>
                      </div>
                    }
                  </div>
                  <br />
                </div>
              }
            </div>
          }
          @default {
            <div>{{ 'Einstellung folgt.' | mrTranslate }}</div>
          }
        }
      </div>
    </div>
  </div>
</clr-modal>
